/**
 * Departments Service Hooks
 * React hooks for accessing department management services
 */
import { useCCMS } from '../useCCMS';
/**
 * Hook to access all department-related services
 * @returns DepartmentsServices object containing all department service instances
 */
export function useDepartmentsServices() {
    const { services } = useCCMS();
    if (!services?.departments) {
        throw new Error('Departments services not available. Ensure CCMSProvider is configured with departments services.');
    }
    return services.departments;
}
/**
 * Hook to access DepartmentService
 */
export function useDepartmentService() {
    return useDepartmentsServices().department;
}
/**
 * Hook to access DesignationService
 */
export function useDesignationService() {
    return useDepartmentsServices().designation;
}
/**
 * Hook to access DesignationTaskService
 */
export function useDesignationTaskService() {
    return useDepartmentsServices().designationTask;
}
/**
 * Hook to access MemberDesignationService
 */
export function useMemberDesignationService() {
    return useDepartmentsServices().memberDesignation;
}
/**
 * Hook to access MemberInDepartmentService
 */
export function useMemberInDepartmentService() {
    return useDepartmentsServices().memberInDepartment;
}
/**
 * Hook to access MinistryService
 */
export function useMinistryService() {
    return useDepartmentsServices().ministry;
}
/**
 * Hook to access MinistryActivityService
 */
export function useMinistryActivityService() {
    return useDepartmentsServices().ministryActivity;
}
/**
 * Hook to access MinistryEquipmentService
 */
export function useMinistryEquipmentService() {
    return useDepartmentsServices().ministryEquipment;
}
/**
 * Hook to access MinistryRoleService
 */
export function useMinistryRoleService() {
    return useDepartmentsServices().ministryRole;
}
/**
 * Hook to access MinistryTeamService
 */
export function useMinistryTeamService() {
    return useDepartmentsServices().ministryTeam;
}
/**
 * Hook to access PublicMinistryService (anonymous-friendly ministry reads)
 */
export function usePublicMinistryService() {
    return useDepartmentsServices().publicMinistry;
}
/**
 * Hook to access MyMinistriesService (the signed-in user's own ministries, departments and designations)
 */
export function useMyMinistriesService() {
    return useDepartmentsServices().myMinistries;
}
//# sourceMappingURL=useDepartmentsServices.js.map